import { createContext, useContext } from "react"

import type { Footnote } from "~/api/prismic/types"
import type { FCWithChildren } from "~/types/react"

const FootnotesContext = createContext<Footnote[]>([])

export const useFootnotesContext = (): Footnote[] => {
  return useContext(FootnotesContext)
}

export type FootnotesProviderProps = {
  footnotes: Footnote[]
}

export const FootnotesProvider: FCWithChildren<FootnotesProviderProps> = ({
  children,
  footnotes,
}) => {
  return (
    <FootnotesContext.Provider value={footnotes}>
      {children}
    </FootnotesContext.Provider>
  )
}
